/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { LONG_MONTH_YEAR_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography2 } from '@coursera/cds-core';
import { BellIcon } from '@coursera/cds-icons';

import { getHeadingStyle } from 'bundles/unified-description-page-common/components/modules/product-overview/details/Details';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

// Type that mirrors the first argument of formatDateTimeDisplay using introspection
type FormatDateTimeDisplayValue = Parameters<typeof formatDateTimeDisplay>[0];

type Props = { launchedAt: FormatDateTimeDisplayValue };
const styles = {
  itemTitle: css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    display: block;
  `,
};

const RecentlyUpdatedDetailItem = ({ launchedAt }: Props) => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  return (
    <React.Fragment>
      <BellIcon size="large" css={styles.icon} />
      <Typography2 variant={getHeadingStyle(enableXDPRedesign)} css={styles.itemTitle} component="div">
        {_t('Recently updated!')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {formatDateTimeDisplay(launchedAt, LONG_MONTH_YEAR_DISPLAY)}
      </Typography2>
    </React.Fragment>
  );
};

export default RecentlyUpdatedDetailItem;
